import { Controller } from "stimulus";
import axios from "axios";
export default class extends Controller {
  static targets = ['premModal', 'premForm', 'searchButton', 'backButton', 'listItem']

  connect(){
    $(this.premModalTarget).modal('show')
  }

  // We need to await the modal to be hidden before we can submit the form
  // If we do not await the modal to be hidden, we can't access the underlying form
  closePremModal(){
    return new Promise((resolve, reject) => {
      $(this.premModalTarget).modal('hide')
      $(this.premModalTarget).on('hidden.bs.modal', function (e) {
        resolve()
      })
    })
  }

  handleSubmit(e){
    let entityObject = {}
    let existingRecordCheck = []
    const location = document.querySelector('#location').value
    const entityType = location.slice(0, 6) === 'client' ? 'client' : 'owner'
    const clientId = document.querySelector('#selected_client_id').value

    this.handleSubmitButton(true)

    this.prepareData(entityObject)

    if (Object.keys(entityObject).length === 0){
      $(this.premModalTarget).modal('hide')
      return
    }

    switch (location){
      case ('client_mrt'):
      case ('owner_mrt'):
        this.populateEntityFields(entityObject, entityType)
        this.updateEntity(entityObject, entityType, clientId)
        break
      case ('client_new'):
        this.checkDuplicateRecord(entityObject, existingRecordCheck, entityType).then(() => {
          if (this.checkResponseEquivalence(existingRecordCheck, entityObject, entityType)) {
            $('#modal_flash_container').children().length === 0 ? this.duplicateRecordMessage() : ''
            this.handleSubmitButton(false)
          } else {
            const newClient = {
              client: {
                name: entityObject.name,
                phone1: entityObject.phone1,
                fax: entityObject.fax,
                premises_num: entityObject.premisesNum,
                address_attributes: {
                  addr1: entityObject.addr1,
                  addr2: entityObject.addr2,
                  city: entityObject.city,
                  state: entityObject.state,
                  zip: entityObject.zipcode,
                  country_id: entityObject.country,
                  county: entityObject.county
                }
              }
            }

            this.createNewRecord(newClient, 'client')
          }
        })
        break
      case ('owner_new'):
        this.checkDuplicateRecord(entityObject, existingRecordCheck, entityType).then(() => {
          if (this.checkResponseEquivalence(existingRecordCheck, entityObject, entityType)) {
            $('#modal_flash_container').children().length === 0 ? this.duplicateRecordMessage() : ''
            this.handleSubmitButton(false)
          } else {
            const clientId = document.querySelector('#selected_client_id').value
            const newOwner = {
              owner: {
                name: entityObject.name,
                phone1: entityObject.phone1,
                fax: entityObject.fax,
                premises_num: entityObject.premisesNum,
                client_id: clientId,
                address_attributes: {
                  addr1: entityObject.addr1,
                  addr2: entityObject.addr2,
                  city: entityObject.city,
                  state: entityObject.state,
                  zip: entityObject.zipcode,
                  country_id: entityObject.country,
                  county: entityObject.county
                }
              }
            }

            this.createNewRecord(newOwner, 'owner', clientId)
          }
        })
        break
      }
  }

  // In the MRT pages, once we select a record from the list, we populate the existing fileds
  populateEntityFields(newEntity, entityType){
    this.closePremModal().then(() => {
      'premisesNum' in newEntity ? document.querySelector(`#${entityType}_premises_num`).value = newEntity.premisesNum : document.querySelector(`#${entityType}_premises_num`).value = ''
    })
  }

  // We pull duplicate records from the database based on the name of the entity
  async checkDuplicateRecord(entityObject, container, entityType){
    const type = entityType.slice(0, 6) === 'client' ? 'client' : 'owner'

    await axios({
      url: `/${type}s/ajax_search.json`,
      method: 'GET',
      params: {
        term: entityObject.name,
      }
    }).then(response => {
      container.push(...response.data)
      return container
    })
  }

  checkResponseEquivalence(container, entityObject, location){
    if (container.length > 0){
      for (let entity of container){
        if (location === 'client' && entity.client.premises_num === entityObject.premisesNum) {
          return true
        } else if (location === 'owner' && entity.owner.premises_num === entityObject.premisesNum) {
          return true
        } else return false
      }
    }
  }

  // We merge the multiple data attributes into a single object
  prepareData(newEntity){
    let activeField = document.querySelector('.active')
    let mergedDataset = {}

    if (!activeField){ return }

    for (let i = 0; i < activeField.children.length; i++){
      let dataset = activeField.children[i].dataset
      mergedDataset = {...mergedDataset, ...dataset}
    }

    for (let key in mergedDataset){
      newEntity[key] = mergedDataset[key]
    }

    return newEntity
  }

  // If coming from the clients/owners index, we create a new record
  // In this situation, we also do not need to populate any existing fields on the page
  createNewRecord(newRecord, entityType, clientId = null){
    axios({
      method: 'post',
      url: entityType === 'client' ? '/clients.json' : `/clients/${clientId}/owners.json`,
      data: newRecord
    }).then((response) => {
      if (response.status === 201) {
        $(this.premModalTarget).modal('hide')
        if (entityType === 'client') {
          // Navigate to the clients show page
          window.location.href = `/clients/${response.data.id}`
        } else {
          // Reload the page to ensure the new owner is in the owners table
          window.location.reload()
        }
      }
    })
  }

  // Update the client/owner record
  updateEntity(updatedData, entityType, clientId){
    const ownerId = entityType === 'owner' ? document.querySelector('#selected_owner_id').value : null
    const updatedPremisesNum = {
      premises_num: updatedData.premisesNum
    }

    if (ownerId === '' && entityType === 'owner'){ return }

    axios({
      method: 'patch',
      url: entityType === 'client' ? `/clients/${clientId}.json` : `/clients/${clientId}/owners/${ownerId}.json`,
      data: updatedPremisesNum
    }).then((response) => {
      if (response.status === 200) {
        $(this.premModalTarget).modal('hide')
      }
    })
  }

  // Add flash messages to inform the user of success/failure
  duplicateRecordMessage(){
    $('#modal_flash_container').append(`<div class="alert alert-warning" id="missing-formats"><i class="fa fa-times-circle fa-2x text-warning"></i>
                                        <div class="warning-text">Record already exists, please choose another</div><a class="close" data-dismiss="alert" href="#">
                                        <span class="fas fa-times"></span></a></div>`)
  }

  handleSubmitButton(ready){
    const submitButton = document.querySelector('#form_submit_button')

    if (ready){
      submitButton.disabled = true
      submitButton.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'
    } else {
      submitButton.disabled = false
      submitButton.innerHTML = $.t('Select')
    }
  }

  // These last functions handle all of the button actions on the modal

  handleSearch(){
    const firstButton = document.querySelector('#search-step')
    const secondButton = document.querySelector('#results-step')

    firstButton.classList.remove('btn-primary')
    firstButton.classList.add('btn-light')

    secondButton.classList.remove('btn-light')
    secondButton.classList.add('btn-primary')

    const inputField = document.querySelector('#client_premises_searchstr')
    const params = new URLSearchParams({ searchstr: inputField.value, location: 'client' })

    const searchUrl = '/animal_health_premises/animal_health_external_search?' + params.toString()

    Turbo.visit(searchUrl, {action: 'replace', frame: 'client_premises_search_results'})
  }

  handleBack(){
    const firstButton = document.querySelector('#search-step')
    const secondButton = document.querySelector('#results-step')

    firstButton.classList.remove('btn-light')
    firstButton.classList.add('btn-primary')

    secondButton.classList.remove('btn-primary')
    secondButton.classList.add('btn-light')

    const searchUrl = '/animal_health_premises/search_bar_step'

    Turbo.visit(searchUrl, {action: 'replace', frame: 'client_premises_search_results'})
  }

  handleNextPage(){
    const searchstr = document.querySelector('#new_entity_searchstr').value
    const page = parseInt(document.querySelector('#new_entity_page').value)
    const params = new URLSearchParams({ searchstr: searchstr, location: 'client', page: (page + 1) })

    const searchUrl = '/animal_health_premises/animal_health_external_search?' + params.toString()

    Turbo.visit(searchUrl, {action: 'replace', frame: 'client_premises_search_results'})
  }

  handlePrevPage(){
    const searchstr = document.querySelector('#new_entity_searchstr').value
    const page = parseInt(document.querySelector('#new_entity_page').value)
    const params = new URLSearchParams({ searchstr: searchstr, location: 'client', page: (page - 1) })

    const searchUrl = '/animal_health_premises/animal_health_external_search?' + params.toString()

    Turbo.visit(searchUrl, {action: 'replace', frame: 'client_premises_search_results'})
  }

  handleSelect(e){
    let activeField = document.querySelector('.active')
    const submitButton = document.querySelector('#form_submit_button')

    if (activeField){
      activeField.classList.toggle('active')
    }

    e.currentTarget.classList.toggle('active')
    submitButton.disabled = false
  }
}